import { motion } from "framer-motion"
import { ChevronRight, School, GraduationCap, LibraryBig } from "lucide-react"
import HeroImage from "../assets/hero.png"
import { F_START_LOGIN } from "../../../constants/routes"

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-gradient-to-tr from-black/10 to-transparent blur-3xl" />
        <div className="absolute -right-24 top-32 h-72 w-72 rounded-full bg-gradient-to-tr from-gray-400/20 to-transparent blur-3xl" />
      </div>
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-16 sm:px-6 lg:grid-cols-12 lg:py-24 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="order-2 space-y-6 lg:order-1 lg:col-span-6">
          <span className="inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium">
            <GraduationCap className="h-3.5 w-3.5" /> Von Schülern. Für Schüler.
          </span>
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">Mehr Nachhaltigkeit im Schulalltag. Weniger ungenutzte Bücher.</h1>
          <p className="text-lg text-gray-600">
            Bookay verbindet Schüler innerhalb einer Schule und macht den Kauf und Verkauf gebrauchter Schulbücher einfach, lokal und kostengünstig.
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <a href={F_START_LOGIN} className="inline-flex items-center gap-2 rounded-xl bg-black px-5 py-3 text-black bookay-bg">
              Zur App <ChevronRight className="h-4 w-4" />
            </a>
            <a href="#loesung" className="inline-flex items-center gap-2 rounded-xl border px-5 py-3">
              Warum Bookay?
            </a>
          </div>
          <div className="flex items-center gap-6 pt-2 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <LibraryBig className="h-4 w-4" /> Digitale Buchverwaltung
            </div>
            <div className="flex items-center gap-2">
              <School className="h-4 w-4" /> Individuelle Schulmodule
            </div>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="order-1 lg:order-2 lg:col-span-6">
          <div className="relative mx-auto aspect-[5/6] w-full max-w-md overflow-hidden rounded-3xl shadow-2xl">
            <img src={HeroImage} alt="Hero Watch" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="absolute bottom-4 left-4 rounded-xl bg-white/90 px-4 py-2 text-sm shadow-sm">
              Kostenlose Testversion
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
